module.exports = __webpack_public_path__ + "img/service3-00.3326e610.png";